export default function(context,DOM){
    context.commit('set_sorting_options',JSON.parse(DOM.dataset.sortoptions ? DOM.dataset.sortoptions : '[]'))
}